import type { FormConfig } from '@tencent/wb-ext-form';
import { FormItemName, FormItemType } from '@framework/workbench/drawer/constants';
import { COLOR_STYLE } from '@src/framework/workbench/drawer/common/config';
import i18n from '@i18next/i18n';
import { textStyle } from '@framework/workbench/drawer/ui/fill/constants';

export const FORM_CONFIGS: FormConfig[] = [
    {
        type: FormItemType.CUSTOM,
        name: FormItemName.TABLE_BORDER_COLOR,
        style: COLOR_STYLE,
    },
    {
        type: FormItemType.TEXT,
        name: FormItemName.TABLE_BORDER_COLOR_TEXT,
        value: i18n.t('颜色'),
        style: textStyle,
    },
];
